// Hit社のみの対応。対象が増えてきた場合はベンダー設定画面に持つなどの改修を要検討
const OUTDOOR_VENDOR_LIST = [8];
export const isOutdoorVendor = (vendorId: number) : boolean => {
  return OUTDOOR_VENDOR_LIST.includes(vendorId);
};
